<template>
	<div class="news">
		<div class="banner">
			<img v-if="inwidth>768" :src="banner" alt="">
			<img v-else :src="phone_pic" alt="">
		</div>
		<div class="content" v-if="mobshow">
			<div class="title">News</div>
			<div class="nav">
				<div class="navlist" v-for="(item,index) in navList" :key="index" @click="changeNav(index,item.id)">
					<div class="navtit" :class="navindex==index?'navactit':''">{{item.class_name}}</div>
				</div>
			</div>
			<div class="contlist">
				<div class="mylist animate__animated animate__fadeInUp wow"  v-for="(item,index) in dataList" :key="index" @click="goDetail(item.id)"
				 data-wow-offset="10">
					<div class="myimg"><img :src="item.pic" alt=""></div>
					<div class="mytit">{{item.title}}</div>
					<div class="mytime">
						<div class="timelt"><i class="iconfont icon-shijian"></i>{{item.add_time}}</div>
						<!-- <div class="timert"><img src="../../../static/images/newsarrow.png" alt=""></div> -->
					</div>
				</div>
				<div class="tips" v-if="myshow"></div>
			</div>
		</div>
		<div class="content" v-else>
			<div class="title">{{title1}}</div>
			<div class="contlist">
				<div class="mylist animate__animated animate__fadeInUp wow"  v-for="(item,index) in dataList1" :key="index" @click="goDetail(item.id)"
				 data-wow-offset="10">
					<div class="myimg"><img :src="item.pic" alt=""></div>
					<div class="mytit">{{item.title}}</div>
					<div class="mytime">
						<div class="timelt"><i class="iconfont icon-shijian"></i>{{item.add_time}}</div>
					</div>
				</div>
			</div>
			<div class="title" style="margin-top: 3rem;">{{title2}}</div>
			<div class="contlist">
				<div class="mylist animate__animated animate__fadeInUp wow"  v-for="(item,index) in dataList2" :key="index" @click="goDetail(item.id)"
				 data-wow-offset="10">
					<div class="myimg"><img :src="item.pic" alt=""></div>
					<div class="mytit">{{item.title}}</div>
					<div class="mytime">
						<div class="timelt"><i class="iconfont icon-shijian"></i>{{item.add_time}}</div>
					</div>
				</div>
			</div>
			<el-pagination background layout="prev,pager,next" :pager-count='pagercount'
			 :hide-on-single-page="pagehide" :page-size="list_row" :current-page.sync='page' :total="totalCount"
			 @current-change='designerList_page'></el-pagination>
		</div>
		
	</div>
</template>

<script>
	import {
		WOW
	} from 'wowjs';
	export default {
		name: "news",
		data() {
			return {
				mobshow: false,
				myshow: false,
				mystate: false,
				inwidth:window.innerWidth,
				banner: '',
				phone_pic:'',
				navList: [{
					name: 'Company News'
				}, {
					name: 'Industry News'
				}],
				navindex: 0,
				cate_id: '',
				dataList: [],
				dataList1: [],
				dataList2: [],
				list_row: 8,
				page: 1,
				totalCount: 1,
				pagehide: true,
				pagercount: 5,
				title1:'',
				title2:'',
				cate_id1:'',
				cate_id2:'',
			}
		},
		created() {
			let width = window.innerWidth
			if (width <= 750) {
				this.mobshow = true
			}else{
				if(this.$route.query.npage){
					this.page = Number(this.$route.query.npage);
				}else{
					this.page=1
				}
			}
			this.getData()
			
		},
		mounted() {
			if (this.mobshow) {
				window.addEventListener('scroll', this.onScroll)
			}
		},
		methods: {
			getData() {
				var that = this;
				let data = {};
				that.$api.newsCate(data).then(res => {
					if (res.status == 1) {
						that.banner = res.data.banner;
						that.phone_pic = res.data.phone_pic;
						that.navList = res.data.list;
						that.title1 = res.data.list[0].class_name
						that.title2 = res.data.list[1].class_name
						that.cate_id = res.data.list[0].id
						that.cate_id1 = res.data.list[0].id
						that.cate_id2 = res.data.list[1].id
						if(that.mobshow){
							that.getList(1)
						}else{
							that.getList1(that.page)
							that.getList2(that.page)
						}
						
					} else {
						that.$message({
							message: res.msg,
							type: "warning"
						});
					}
				});
			},
			getList(page) {
				var that = this;
				let data = {
					page: page,
					list_row: that.list_row,
					cate_id: that.cate_id,
				};
				if (that.mobshow) {
					let mylist = that.dataList
					that.$api.newsList(data).then(res => {
						if (res.status == 1) {
							mylist = mylist.concat(res.data.list)
							that.dataList = mylist;
							that.totalCount = res.data.pageInfo.totalCount
							that.myshow = false
							that.page = page
							that.mystate = true
						} else {
							that.$message({
								message: res.msg,
								type: "warning"
							});
						}
					});
				}
			},
			getList1(page) {
				var that = this;
				let data = {
					page: page,
					list_row: that.list_row,
					cate_id: that.cate_id1,
				};		
				that.$api.newsList(data).then(res => {
					if (res.status == 1) {
						that.dataList1 = res.data.list;
						if(res.data.pageInfo.totalCount>that.totalCount){
							that.totalCount = res.data.pageInfo.totalCount
						}
					} else {
						that.$message({
							message: res.msg,
							type: "warning"
						});
					}
				});	
			},
			getList2(page) {
				var that = this;
				let data = {
					page: page,
					list_row: that.list_row,
					cate_id: that.cate_id2,
				};		
				that.$api.newsList(data).then(res => {
					if (res.status == 1) {
						that.dataList2 = res.data.list;
						if(res.data.pageInfo.totalCount>that.totalCount){
							that.totalCount = res.data.pageInfo.totalCount
						}
					} else {
						that.$message({
							message: res.msg,
							type: "warning"
						});
					}
				});	
			},
			changeNav(index, id) {
				this.navindex = index
				this.cate_id = id
				this.page = 1
				this.dataList = []
				this.getList(1)
			},
			designerList_page(currentPage) {
				this.$router.push({
					path: '/news',
					query: {
						npage:currentPage,
					}
				});
				this.getList1(currentPage)
				this.getList2(currentPage)
			},
			goDetail(id) {
				this.$router.push({
					path: '/newsDetail',
					query: {
						newsid: id
					}
				});
			},
			//滚动触底加载
			onScroll() {
				var that = this
				let height = $('.footer').height()
				if (that.mystate) {
					if (that.getScrollHeight() <= that.getWindowHeight() + that.getDocumentTop() + height) {
						that.mystate = false
						if (that.totalCount > that.dataList.length) {
							let page = that.page + 1
							that.getList(page) //请求接口的函数
							that.myshow = false
						} else {
							that.myshow = true
						}
					}
				}
			},
			//文档高度
			getDocumentTop() {
				var scrollTop = 0,
					bodyScrollTop = 0,
					documentScrollTop = 0;
				if (document.body) {
					bodyScrollTop = document.body.scrollTop;
				}
				if (document.documentElement) {
					documentScrollTop = document.documentElement.scrollTop;
				}
				scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
				return scrollTop;
			},
			//可视窗口高度
			getWindowHeight() {
				var windowHeight = 0;
				if (document.compatMode == "CSS1Compat") {
					windowHeight = document.documentElement.clientHeight;
				} else {
					windowHeight = document.body.clientHeight;
				}
				return windowHeight;
			},
			//滚动条滚动高度
			getScrollHeight() {
				var scrollHeight = 0,
					bodyScrollHeight = 0,
					documentScrollHeight = 0;
				if (document.body) {
					bodyScrollHeight = document.body.scrollHeight;
				}
				if (document.documentElement) {
					documentScrollHeight = document.documentElement.scrollHeight;
				}
				scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
				return scrollHeight;
			},
		},
		beforeDestroy() {//清除监听
        	window.removeEventListener('scroll', this.onScroll)
  		},	

	}
</script>

<style>
	.news {
		width: 100%;
		background: #fff;
	}

	.news .banner {
		width: 100%;
	}

	.news .banner img {
		width: 100%;
		display: block;
	}

	.news .content {
		width: 120rem;
		margin: 0 auto;
		padding: 3.0rem 0 5.0rem;
	}

	.news .title {
		width: 100%;
		padding: 0.6rem 0 1.0rem;
		text-align: center;
		font-size: 3.6rem;
		font-weight: bold;
		color: #4c4c4c;
		letter-spacing: 0.2rem;
	}

	.news .nav {
		width: 100%;
		border-bottom: 1px solid #e6e6e6;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.news .nav .navlist {
		margin-left: 13.0rem;
		cursor: pointer;
	}

	.news .nav .navlist:first-child {
		margin-left: 0;
	}

	.news .nav .navlist .navtit {
		height: 3.6rem;
		line-height: 3.6rem;
		padding: 0 0.2rem;
		box-sizing: border-box;
		border-bottom: 2px solid transparent;
		font-size: 1.6rem;
		color: #999;
		text-align: center;
	}

	.news .nav .navlist .navactit {
		border-bottom: 2px solid #000;
		color: #333;
	}

	.news .contlist {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		margin: auto;
	}

	.news .mylist {
		margin-right: 1.7rem;
		margin-top: 4.0rem;
		width: 28.7rem;
		border-radius: 6px;
		box-sizing: border-box;
		/* border: 1px solid #e6e6e6; */
		cursor: pointer;
	}

	.news .mylist:hover {
		box-shadow: 0px 10px 10px #f5f5f5;
	}

	.news .mylist:nth-child(4n) {
		margin-right: 0;
	}

	.news .mylist .myimg {
		width: 100%;
		overflow: hidden;
	}

	.news .mylist .myimg img {
		width: 100%;
		display: block;
		transition: all 1s;
		-moz-transition: all 1s;
		-webkit-transition: all 1s;
	}

	.news .mylist:hover .myimg img {
		transform: scale(1.2);
		-webkit-transform: scale(1.2);
		-moz-transform: scale(1.2);
	}

	.news .mylist .mytit {
		width: 100%;
		height: 7.0rem;
		box-sizing: border-box;
		overflow: hidden;
		padding: 1rem 0.8rem;
		line-height: 2.6rem;
		/* border-top: 1px solid #e6e6e6;
		border-bottom: 1px solid #e6e6e6; */
		text-align: center;
		font-size: 1.6rem;
		color: #202020;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	.news .mylist .mytime {
		width: 100%;
		height: 4rem;
		box-sizing: border-box;
		overflow: hidden;
		display: flex;
		justify-content: center;
	}

	.news .mylist .mytime .timelt {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		text-align: left;
		font-size: 1.4rem;
		color: #4d4d4d;
	}

	.news .mylist .mytime .timelt i {
		margin-right:1.2rem;
	}

	.news .mylist .mytime .timert {
		width: 5.0rem;
		height: 4rem;
		line-height: 4rem;
		text-align: center;
		/* border-left: 1px solid #e6e6e6; */
	}

	.news .mylist .mytime .timert img {
		width: 1.4rem;
		height: 1.2rem;
	}

	.news .content .el-pagination {
		margin-top: 5.0rem;
		width: 100%;
		text-align: center;
	}

	.news .content .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #0c131b;
		color: #ffffff;
	}

	.news .content .el-pagination.is-background .btn-next,
	.el-pagination.is-background .btn-prev,
	.el-pagination.is-background .el-pager li {
		width: 4rem;
		height: 4rem;
		line-height: 4rem;
		font-size: 1.4rem;
		border-radius: 0;
		color: #868686;
		background-color: #ebebeb;
	}

	.news .content .el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #868686;
	}
	.tips{
		width: 100%;
		text-align: center;
		padding: 2rem 0 0;
		font-size: 1.4rem;
		color:#4c4c4c;
	}
	@media(max-width:1200px) {
		.news .content {
			width: 95%;
		}

		.news .contlist {
			width: 89.5rem;
		}

		.news .mylist:nth-child(3n) {
			margin-right: 0;
		}

		.news .mylist:nth-child(4n) {
			margin-right: 1.7rem;
		}
	}

	@media(max-width:900px) {
		.news .content {
			width: 95%;
		}

		.news .contlist {
			width: 59.1rem;
		}

		.news .mylist:nth-child(2n+1) {
			margin-right: 1.7rem;
		}

		.news .mylist:nth-child(2n) {
			margin-right: 0;
		}
	}

	@media(max-width:768px) {
		.news .content {
			width: 85%;
		}

		.news .banner img {
			height: 40.0rem;
			object-fit: cover;
		}
	}

	@media(max-width:750px) {
		.news .nav .navlist {
			margin-left: 7rem;
		}

		.news .contlist {
			width: 100%;
			justify-content: center;
		}

		.news .mylist:nth-child(2n+1) {
			margin-right: 0;
		}

		.news .mylist:nth-child(2n) {
			margin-right: 0;
		}
	}
	@media(max-width: 370px){
		.news .nav .navlist {
			margin-left: 6rem;
		}
	}
	@media(max-width: 350px){
		.news .nav .navlist {
			margin-left: 3rem;
		}
	}
</style>
